// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qZN2t","label":"styles_label__35buO"};